module.exports = __webpack_public_path__ + "assets/blob-1-selected.846f8f92.svg";